import { useState } from 'react';
import { VideoInterface } from '../../../contexts/VideoContext';

interface Props {
  videos: VideoInterface[]
  selectedId: number
  handleSelected: (id: number) => void
}

const Index = (props: Props) => {
  const { videos, handleSelected, selectedId } = props;
  const [currentId, setCurrentId] = useState(selectedId);

  const handleClick = (id: number) => {
    setCurrentId(id);
    handleSelected(id);
  };

  return ((
    <div className="videoList">
      <ul>
        {videos.map((video) => (
          <div
            onClick={() => handleClick(video.id)}
            style={{
              marginBottom: '5px',
              border: currentId === video.id ? '2px solid blue' : '2px solid rgba(0, 0, 0, 0.2)',
              borderRadius: '5px',
              padding: '5px',
            }}
          >
            {video.file_name}
          </div>
        ))}
      </ul>
    </div>
  ));
};

export default Index;
